import { AUTHORIZATION_HEADER } from '../../../src/authorization';
import { send } from '../../../src/network';
import { type BaseTag } from '../../../src/types/Tag';

export interface GetTagGroupResponse {
  id: number;
  name: string;
  remark: string | null;
  thumbnail_url: string | null;
  tags: Array<BaseTag[]>;
}

export interface GetTagGroupParams {
  tagGroupId: number;
  expandDislikes?: boolean;
}

export async function getTagGroup(params: GetTagGroupParams) {
  const { tagGroupId, expandDislikes } = params;
  const query = new URLSearchParams();

  query.append('tag_group_id', tagGroupId.toString());

  if (expandDislikes) {
    query.append('expand_dislikes', '1');
  }

  return await send<GetTagGroupResponse>({
    path: '/api/get_tag_group/',
    method: 'GET',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
